import * as Crypto from 'expo-crypto';

export const generateIdempotencyKey = async (
  data: unknown,
): Promise<string> => {
  const json = JSON.stringify(data);
  return await Crypto.digestStringAsync(
    Crypto.CryptoDigestAlgorithm.SHA256,
    json,
  );
};
